import { FieldProps } from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import { formSubmissionActions } from "@common/redux/formSubmission/actions";
import {
  ICheckDuplicateSubmissionFieldResponse,
  ICheckDuplicateSubmissionFieldSuccessResponsePayload,
  IFormSubmission,
  IFormSubmissionMap,
  IFormSubmissionReducerState,
  IFormSubmissionSettingsMap,
  IFormSubmissionsPaginationMap,
  ISubmissionFormDataServer,
  ISubmissionMap,
  IUniversalStorageData,
} from "./interface";
import { DataUtility as _ } from "@utils/DataUtility";
import { transFormSubmissionDataServerToClient } from "./utils";

export const initialState: IFormSubmissionReducerState = {
  activeFormSubmission: {
    localId: "",
    fieldSubmissionMap: {},
  } as IFormSubmission,
  isDraftSubmission: false,
  activeFormCompositeKeySubmission: {
    isCompositeKeySuccess: false,
    compositeFieldSubmissionMap: {},
  } as IFormSubmission,
  formSubmissionMap: {},
  referenceCopyFormSubmissionMap: {},
  formSubmissionsPaginationMap: {}, //added to store total items and total Page
  submissionMap: {},
  isPreview: false,
  formSubmissionSettingsMap: {},
  respondedByDetails: {},
  universalStorageUnit: {
    paramsData: {},
  },
  isFormBuilderAsComponent: false,
  mySubmissions: {
    mySubmissionpaginationData: {},
    mySubmissionIds: [],
  },
  linkedFieldsToLookup: [],
  linkedFieldLookupOptions: {},
  mappedLookupOptions: {
    optionsMap: {}
  },

  dataGridActionsMapper: {},
  dataGridTableValues: {},
  dataGridCompositeKeysValidationMapper: {},
  isSamePage: false,
  visitedPages: [],
  loaders: {
    addFormSubmission: false,
    addFormBulkSubmission: false,
    fetchFormSubmissions: false,
    deleteFormSubmission: false,
    deleteDatagridFormSubmission: false,
    updateFormSubmission: false,
    fetchFormSubmissionSettings: false,
    fetchMySubmissions: false,
    setActiveFormSubmission: false,
    checkDuplicateSubmission: false,
  },
  errors: {
    addFormSubmission: "",
    addFormBulkSubmission: "",
    fetchFormSubmissions: "",
    deleteFormSubmission: "",
    deleteDatagridFormSubmission: "",
    updateFormSubmission: "",
    fetchFormSubmissionSettings: "",
    fetchMySubmissions: "",
    fetchSubmissionBySubmissionId: "",
    checkDuplicateSubmission: "",
  },
  openedDate: Date.now(),
  otpResponse: null,
  otpLoading: false,
  otpError: "",
};

export const formSubmissionReducer = (
  state: IFormSubmissionReducerState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case formSubmissionActions.ADD_LINKEDFIELDS_LOOKUP: {
      const linkedFieldIds = action?.payload?.fieldIds ?? [];
      return {
        ...state,
        linkedFieldsToLookup: linkedFieldIds,
      };
    }
    case formSubmissionActions.ADD_LINKEDFIELDS_VALUES: {
      const linkedFieldLookupOptions = action?.payload ?? [];
      return {
        ...state,
        linkedFieldLookupOptions: linkedFieldLookupOptions,
      };
    }

    case formSubmissionActions.ADD_MAPPED_VALUES: {
      const { optionsMap } = action.payload ?? {};
      if (!optionsMap) return state;

      return {
        ...state,
        mappedLookupOptions: {
          ...state.mappedLookupOptions,
          optionsMap: {
            ...(state.mappedLookupOptions?.optionsMap || {}),
            ...optionsMap,
          },
        },
      };
    }

    case formSubmissionActions.RESET_LINKEDFIELDS_VALUES: {
      return {
        ...state,
        linkedFieldLookupOptions: [],
      };
    }
    case formSubmissionActions.SET_SUBMISSION_TYPE: {
      const isDraft = action.payload ?? false;
      return {
        ...state,
        isDraftSubmission: isDraft,
      };
    }

    case formSubmissionActions.ADD_DATAGRID_SUBMISSION_ACTIONS: {
      const { fieldId, submissionId, actionType } = action.payload;

      return {
        ...state,
        dataGridActionsMapper: {
          ...state.dataGridActionsMapper,
          [fieldId]: {
            ...state.dataGridActionsMapper[fieldId],
            [submissionId]: actionType,
          },
        },
      };
    }
    case formSubmissionActions.UPDATE_DATAGRID_TABLE_VALUE: {
      const { fieldId, tableValue } = action.payload;

      return {
        ...state,
        dataGridTableValues: {
          ...state.dataGridTableValues,
          [fieldId]: tableValue,
        },
      };
    }
    case formSubmissionActions.ADD_DATAGRID_COMPOSITE_KEYS_VALIDATION: {
      const { fieldId, actionType } = action.payload;
      return {
        ...state,
        dataGridCompositeKeysValidationMapper: {
          ...state.dataGridCompositeKeysValidationMapper,
          [fieldId]: actionType,
        },
      };
    }
    case formSubmissionActions.SET_IS_SAME_PAGE: {
      const { actionType } = action.payload;
      return {
        ...state,
        isSamePage: actionType,
      };
    }
    case formSubmissionActions.ADD_VISITED_PAGE: {
      const { pageId } = action.payload;
      const alreadyVisited = state.visitedPages?.includes(pageId);
      return {
        ...state,
        visitedPages: alreadyVisited
          ? state.visitedPages
          : [...(state.visitedPages || []), pageId],
      };
    }
    case formSubmissionActions.RESET_VISITED_PAGES: {
      return {
        ...state,
        visitedPages: [],
      };
    }

    case formSubmissionActions.ADD_NEW_FIELD: {
      const index = action.payload.index;

      const fieldInitialization = action.payload.fieldInitialization;

      const existingFieldMap =
        state.activeFormSubmission?.fieldSubmissionMap ?? {};

      const updatedFieldMap = addNewFieldMap(
        [fieldInitialization as FieldProps],
        existingFieldMap
      );
      return {
        ...state,
        activeFormSubmission: {
          ...state.activeFormSubmission,

          fieldSubmissionMap: updatedFieldMap,
        },
        // referenceCopyFormSubmissionMap: updatedFieldMap,
      };
    }

    case formSubmissionActions.UPDATE_FIELD_DATA: {
      return {
        ...state,
      };
    }

    case formSubmissionActions.UPDATE_FIELD_DATA_SUCCESS: {
      const index = action.payload.index;
      const updatedFieldData = action.payload.data;
      const existingFieldMap =
        state.activeFormSubmission?.fieldSubmissionMap ?? {};
      const updatedFieldMap = getUpdatedFieldMap(
        [updatedFieldData],
        existingFieldMap
      );
      return {
        ...state,
        activeFormSubmission: {
          ...state.activeFormSubmission,
          fieldSubmissionMap: updatedFieldMap,
        },
      };
    }

    case formSubmissionActions.BULK_UPDATE_FORM_DATA: {
      return {
        ...state,
      };
    }
    case formSubmissionActions.BULK_UPDATE_FORM_DATA_SUCCESS: {
      const fieldSubmissionMap = action.payload.data;
      const existingFieldMap =
        state.activeFormSubmission?.fieldSubmissionMap ?? {};

      const updatedFieldMap =
        (fieldSubmissionMap &&
          getUpdatedFieldMap(fieldSubmissionMap, existingFieldMap)) ||
        existingFieldMap;
      return {
        ...state,
        activeFormSubmission: {
          ...state.activeFormSubmission,
          fieldSubmissionMap: updatedFieldMap,
        },
      };
    }
    case formSubmissionActions.BULK_UPDATE_FORM_DATA_FOR_VALIDATION: {
      const fieldSubmissionMap = action.payload.data;

      const existingFieldMap =
        state.activeFormSubmission?.fieldSubmissionMap ?? {};

      const updatedFieldMap =
        (fieldSubmissionMap &&
          getUpdatedFieldMap(fieldSubmissionMap, existingFieldMap)) ||
        existingFieldMap;

      return {
        ...state,
        activeFormSubmission: {
          ...state.activeFormSubmission,
          fieldSubmissionMap: updatedFieldMap,
        },
      };
    }
    case formSubmissionActions.SET_UNIVERSAL_STORAGE_UNIT: {
      const universalStorageData: IUniversalStorageData = action.payload;
      const existingUniversalStorageUnit = { ...state?.universalStorageUnit };

      for (const key in universalStorageData) {
        const item = universalStorageData[key];
        existingUniversalStorageUnit[key] = item;
      }

      return {
        ...state,
        universalStorageUnit: existingUniversalStorageUnit,
      };
    }
    case formSubmissionActions.SET_FORMBUILDER_AS_COMPONENT: {
      return {
        ...state,
        isFormBuilderAsComponent: action.payload,
      };
    }
    case formSubmissionActions.RESET_SUBMISSION_FORM: {
      return {
        ...state,
        activeFormSubmission: initialState.activeFormSubmission,
      };
    }

    case formSubmissionActions.SET_ACTIVE_FORM_SUBMISSION: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          setActiveFormSubmission: true,
        },
      };
    }

    case formSubmissionActions.SET_ACTIVE_FORM_SUBMISSION_SUCCESS: {
      const activeFormSubmissionId = action.payload.activeFormSubmissionId;
      const submissionMap = state.submissionMap;
      let activeFormSubmission: IFormSubmission;
      if (submissionMap[activeFormSubmissionId]) {
        activeFormSubmission = submissionMap[activeFormSubmissionId];
      }
      return {
        ...state,
        activeFormSubmission: activeFormSubmission,
        loaders: {
          ...state.loaders,
          setActiveFormSubmission: false,
        },
      };
    }

    case formSubmissionActions.ADD_FORM_SUBMISSION: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          addFormSubmission: true,
        },
        errors: {
          ...state.errors,
          addFormSubmission: "",
        },
      };
    }

    case formSubmissionActions.ADD_FORM_SUBMISSION_SUCCESS: {
      const formId = action?.payload?.formSubmissionData?.localId;
      const formSubmissionId =
        action?.payload?.formSubmissionData?.submissionId;
      const fieldSubmissionMap =
        action?.payload?.formSubmissionData?.fieldSubmissionMap;

      const submissionIdsMapByFormId = state.formSubmissionMap || {};
      submissionIdsMapByFormId[formId] = submissionIdsMapByFormId[formId]
        ? [...submissionIdsMapByFormId[formId], formSubmissionId]
        : [formSubmissionId];

      const submissionMap = state.submissionMap || {};
      const newFormSubmission = _.cloneDeep(initialState.activeFormSubmission);
      newFormSubmission.localId = formId;
      newFormSubmission.submissionId = formSubmissionId;
      newFormSubmission.fieldSubmissionMap = fieldSubmissionMap;

      const updatedsubmissionMap = {
        ...submissionMap,
        [formSubmissionId]: newFormSubmission,
      };

      return {
        ...state,
        formSubmissionMap: submissionIdsMapByFormId,
        submissionMap: updatedsubmissionMap,
        activeFormSubmission: {
          ...state.activeFormSubmission,
          submissionId: formSubmissionId,
        },
        loaders: {
          ...state.loaders,
          addFormSubmission: false,
        },
      };
    }

    case formSubmissionActions.ADD_FORM_SUBMISSION_ERROR: {
      const error = action.payload.error;

      return {
        ...state,
        errors: {
          ...state.errors,
          addFormSubmission: error,
        },
        loaders: {
          ...state.loaders,
          addFormSubmission: false,
        },
      };
    }
    case formSubmissionActions.ADD_FORM_BULK_SUBMISSION: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          addFormBulkSubmission: true,
        },
        errors: {
          ...state.errors,
          addFormBulkSubmission: "",
        },
      };
    }

    case formSubmissionActions.ADD_FORM_BULK_SUBMISSION_SUCCESS: {
      console.log(action?.payload, "ADD_FORM_SUBMISSION_SUCCESS");
    }

    case formSubmissionActions.ADD_FORM_BULK_SUBMISSION_ERROR: {
      const error = action.payload.error;

      return {
        ...state,
        errors: {
          ...state.errors,
          addFormBulkSubmission: error,
        },
        loaders: {
          ...state.loaders,
          addFormBulkSubmission: false,
        },
      };
    }

    case formSubmissionActions.DELETE_FORM_SUBMISSION: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          deleteFormSubmission: true,
        },
        errors: {
          ...state.errors,
          deleteFormSubmission: "",
        },
      };
    }
    case formSubmissionActions.DELETE_FORM_SUBMISSION_SUCCESS: {
      const index = action.payload.index;
      const formId = action.payload.formId;

      const formSubmissionMap = state.formSubmissionMap;
      const submissionMap = state.submissionMap;
      const submissionFormId = formSubmissionMap[formId][index];
      formSubmissionMap[formId] = [
        ...formSubmissionMap[formId].slice(0, index),
        ...formSubmissionMap[formId].slice(index + 1),
      ];
      delete submissionMap[submissionFormId];

      return {
        ...state,
        formSubmissionMap: formSubmissionMap,
        submissionMap: submissionMap,
        loaders: {
          ...state.loaders,
          deleteFormSubmission: false,
        },
      };
    }

    case formSubmissionActions.DELETE_FORM_SUBMISSION_ERROR: {
      const error = action.payload.error;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          deleteFormSubmission: false,
        },
        errors: {
          ...state.errors,
          deleteFormSubmission: error,
        },
      };
    }
    case formSubmissionActions.DELETE_DATAGRID_FORM_SUBMISSION: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          deleteDatagridFormSubmission: true,
        },
        errors: {
          ...state.errors,
          deleteDatagridFormSubmission: "",
        },
      };
    }
    case formSubmissionActions.DELETE_DATAGRID_SUBMISSION_SUCCESS: {
      const { response } = action.payload;
      console.log(response, "response, -DELETE_DATAGRID_SUBMISSION_SUCCESS-");
    }

    case formSubmissionActions.DELETE_DATAGRID_SUBMISSION_ERROR: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          deleteDatagridFormSubmission: false,
        },
        errors: {
          ...state.errors,
          deleteDatagridFormSubmission: error,
        },
      };
    }

    case formSubmissionActions.UPDATE_FORM_SUBMISSION: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateFormSubmission: true,
        },
        errors: {
          ...state.errors,
          updateFormSubmission: "",
        },
      };
    }

    case formSubmissionActions.FETCH_FORM_SUBMISSIONS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFormSubmissions: true,
        },
      };
    }

    case formSubmissionActions.FETCH_FORM_SUBMISSIONS_SUCCESS: {
      const { response, fetchedFormsMap } = action.payload;
      const { content, pageNumber, totalElements, totalPages, pageSize } =
        response;
      const formSubmissionsServer: ISubmissionFormDataServer[] = content;
      const updatedSubmissionMap: ISubmissionMap = { ...state.submissionMap };
      const updatedformSubmissionsPaginationMap: IFormSubmissionsPaginationMap =
        { ...state.formSubmissionsPaginationMap };
      const updatedFormsubmissionIdsMap: IFormSubmissionMap = {};

      formSubmissionsServer.forEach(
        (formSubmissionServer: ISubmissionFormDataServer) => {
          const { formId, id } = formSubmissionServer;
          const updatedFormSubmissionsIds: string[] =
            updatedFormsubmissionIdsMap[formId] || [];
          updatedSubmissionMap[id] = transFormSubmissionDataServerToClient(
            formSubmissionServer,
            fetchedFormsMap[formId],
            []
          );
          updatedFormsubmissionIdsMap[formId] = [
            ...updatedFormSubmissionsIds,
            id,
          ];
          updatedformSubmissionsPaginationMap[formId] = {
            pageNumber,
            totalElements,
            totalPages,
            pageSize,
          };
        }
      );

      return {
        ...state,
        // referenceCopyFormSubmissionMap: {
        //   ...state.formSubmissionMap,
        //   updatedSubmissionMap
        // },
        formSubmissionMap: {
          ...state.formSubmissionMap,
          ...updatedFormsubmissionIdsMap,
        },
        formSubmissionsPaginationMap: updatedformSubmissionsPaginationMap,
        submissionMap: updatedSubmissionMap,
        loaders: {
          ...state.loaders,
          fetchFormSubmissions: false,
        },
      };
    }

    case formSubmissionActions.FETCH_FORM_SUBMISSIONS_ERROR: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFormSubmissions: false,
        },
        errors: {
          ...state.errors,
          fetchFormSubmissions: error,
        },
      };
    }

    case formSubmissionActions.UPDATE_FORM_SUBMISSION_SUCCESS: {
      const dbFormattedSubmissionData =
        action.payload.dbFormattedSubmissionData;
      const formatedSubmissionData: IFormSubmission = {
        localId: "",
        fieldSubmissionMap: {},
      };

      // const formSubmissionData = action.payload.formSubmissionData;

      dbFormattedSubmissionData &&
        dbFormattedSubmissionData.fieldSubmissionMap &&
        dbFormattedSubmissionData.fieldSubmissionMap.map((fieldData, index) => {
          formatedSubmissionData.fieldSubmissionMap[fieldData.localId] =
            fieldData;
        });
      formatedSubmissionData.localId = dbFormattedSubmissionData.localId;

      const existingSubmissionMap = state.submissionMap;

      const updatedSubmissionMap = {
        ...existingSubmissionMap,
        [formatedSubmissionData.localId]: formatedSubmissionData,
      };
      return {
        ...state,
        submissionMap: updatedSubmissionMap,
        loaders: {
          ...state.loaders,
          updateFormSubmission: false,
        },
      };
    }

    case formSubmissionActions.UPDATE_FORM_SUBMISSION_ERROR: {
      const error = action.payload.error;

      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateFormSubmission: false,
        },
        errors: {
          ...state.errors,
          updateFormSubmission: error,
        },
      };
    }

    case formSubmissionActions.FORM_SUBMISSIONS_EXPORT: {
      // we're not updating any redux state can we remove it?
      return {
        ...state,
      };
    }

    case formSubmissionActions.RESET_ACTIVE_FORM_SUBMISSION: {
      return {
        ...state,
        activeFormSubmission: initialState.activeFormSubmission,
      };
    }

    case formSubmissionActions.FETCH_FORM_SUBMISSION_SETTINGS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFormSubmissionSettings: true,
        },
        errors: {
          ...state.errors,
          fetchFormSubmissionSettings: "",
        },
      };
    }
    case formSubmissionActions.FETCH_FORM_SUBMISSION_SETTINGS_SUCCESS: {
      const { isMultipleSubmissionAllowed, formId } = action.payload;
      const updatedFormSubmissionSettingsMap: IFormSubmissionSettingsMap = {
        ...state.formSubmissionSettingsMap,
      };
      updatedFormSubmissionSettingsMap[formId] = {
        // need to refactor after proper API response
        ...updatedFormSubmissionSettingsMap[formId],
        isMultipleSubmissionAllowed,
      };

      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFormSubmissionSettings: false,
        },
        formSubmissionSettingsMap: updatedFormSubmissionSettingsMap, //updatedSubmissionAllowed
      };
    }

    case formSubmissionActions.FETCH_FORM_SUBMISSION_SETTINGS_FAILURE: {
      const isMultipleSubmissionAllowed =
        action?.payload?.isMultipleSubmissionAllowed || false;
      const formId = action?.payload?.formId;
      const error = action?.payload?.error;
      const updatedFormSubmissionSettingsMap: IFormSubmissionSettingsMap = {
        ...state.formSubmissionSettingsMap,
      };
      updatedFormSubmissionSettingsMap[formId] = {
        ...updatedFormSubmissionSettingsMap[formId],
        isMultipleSubmissionAllowed,
      };

      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFormSubmissionSettings: false,
        },
        errors: {
          ...state.errors,
          fetchFormSubmissionSettings: error,
        },
        formSubmissionSettingsMap: updatedFormSubmissionSettingsMap,
      };
    }

    case formSubmissionActions.FETCH_MY_SUBMISSIONS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchMySubmissions: true,
        },
        errors: {
          ...state.errors,
          fetchMySubmissions: "",
        },
      };
    }

    case formSubmissionActions.FETCH_MY_SUBMISSIONS_SUCCESS: {
      const { mySubmissionPaginationData, mySubmissionsMap, mySubmissionIds } =
        action.payload;
      const { pageNumber } = mySubmissionPaginationData;
      const updatedMySubmissionIds =
        pageNumber == 0
          ? [...mySubmissionIds]
          : [...state.mySubmissions.mySubmissionIds, ...mySubmissionIds];
      const updatedSubmissionMap = {
        ...state.submissionMap,
        ...mySubmissionsMap,
      };

      return {
        ...state,
        mySubmissions: {
          ...state.mySubmissions,
          mySubmissionpaginationData: mySubmissionPaginationData,
          mySubmissionIds: updatedMySubmissionIds,
        },
        submissionMap: updatedSubmissionMap,
        loaders: {
          ...state.loaders,
          fetchMySubmissions: false,
        },
      };
    }

    case formSubmissionActions.FETCH_MY_SUBMISSIONS_FAILURE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchMySubmissions: false,
        },
        errors: {
          ...state.errors,
          fetchMySubmissions: action.payload.error,
        },
      };
    }

    case formSubmissionActions.FETCH_SUBMISSION_BY_SUBMISSION_ID: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchSubmissionBySubmissionId: true,
        },
        errors: {
          ...state.errors,
          fetchSubmissionBySubmissionId: "",
        },
      };
    }

    case formSubmissionActions.FETCH_SUBMISSION_BY_SUBMISSION_ID_SUCCESS: {
      const { submissionMap } = action.payload;
      const updatedSubmissionMap = {
        ...state.submissionMap,
        ...submissionMap,
      };
      return {
        ...state,
        referenceCopyFormSubmissionMap: updatedSubmissionMap,
        submissionMap: updatedSubmissionMap,
        loaders: {
          ...state.loaders,
          fetchSubmissionBySubmissionId: false,
        },
      };
    }

    case formSubmissionActions.FETCH_SUBMISSION_BY_SUBMISSION_ID_FAILURE: {
      return {
        ...state,
        errors: {
          ...state.errors,
          fetchSubmissionBySubmissionId: action.payload.error,
        },
        loaders: {
          ...state.loaders,
          fetchSubmissionBySubmissionId: false,
        },
      };
    }

    case formSubmissionActions.CHECK_DUPLICATE_VALUE: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          checkDuplicateSubmission: true,
        },
        errors: {
          ...state.errors,
          checkDuplicateSubmission: "",
        },
      };
    }

    case formSubmissionActions.CHECK_DUPLICATE_VALUE_SUCCESS: {
      let duplicateValueExist = false;
      const payloadData: ICheckDuplicateSubmissionFieldSuccessResponsePayload =
        action.payload;
      const duplicateCheckedField: ICheckDuplicateSubmissionFieldResponse[] =
        payloadData.fieldData;
      const duplicateCheckedCompositeField: ICheckDuplicateSubmissionFieldResponse[] =
        payloadData.compositeFieldData;
      const isCompositeKeySuccess: boolean =
        payloadData.isCompositeFieldsDuplicate;
      const existingFieldSubmissionMap = {
        ...(state.activeFormSubmission?.fieldSubmissionMap ?? {}),
      };

      duplicateCheckedField.map(
        (fieldDetails: ICheckDuplicateSubmissionFieldResponse) => {
          const { localId, isDuplicate } = fieldDetails;
          const submissionData = { ...existingFieldSubmissionMap[localId] };
          if (isDuplicate) duplicateValueExist = true;
          existingFieldSubmissionMap[localId] = {
            ...submissionData,
            isError: isDuplicate,
            valueError: isDuplicate
              ? "Duplicate values are disabled, Please try with different value!"
              : "",
          };
        }
      );
      return {
        ...state,
        activeFormSubmission: {
          ...state.activeFormSubmission,
          fieldSubmissionMap: existingFieldSubmissionMap,
          duplicateValueExist,
        },
        activeFormCompositeKeySubmission: {
          ...state.activeFormCompositeKeySubmission,
          compositeFieldSubmissionMap: duplicateCheckedCompositeField,
          isCompositeKeySuccess,
        },
        loaders: {
          ...state.loaders,
          checkDuplicateSubmission: false,
        },
      };
    }

    case formSubmissionActions.RESET_COMPOSITEKEY_DUPLICATE_RESPONSE: {
      return {
        ...state,
        activeFormCompositeKeySubmission: {
          ...state.activeFormCompositeKeySubmission,
          isCompositeKeySuccess: false,
        },
      };
    }

    case formSubmissionActions.CHECK_DUPLICATE_VALUE_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          checkDuplicateSubmission: false,
        },
        errors: {
          ...state.errors,
          checkDuplicateSubmission: action.payload.error,
        },
      };
    }

    case formSubmissionActions.UPDATE_SUBMISSION_RESPONDED_DATA: {
      return {
        ...state,
        respondedByDetails: action.payload,
      };
    }

    case formSubmissionActions.SET_SUBMISSION_DATA_OF_FORM: {
      return {
        ...state,
        submissionDataOfFormField: action.payload.content,
      };
    }

    case formSubmissionActions.OPENED_DATE: {
      return {
        ...state,
        openedDate: action.payload,
      };
    }

    case formSubmissionActions.SEND_OR_VALIDATE_OTP: {
      return {
        ...state,
        otpLoading: true,
        otpError: "",
        otpResponse: null,
      };
    }

    case formSubmissionActions.SEND_OR_VALIDATE_OTP_SUCCESS: {
      return {
        ...state,
        otpLoading: false,
        otpResponse: action.payload,
        otpError: "",
      };
    }

    case formSubmissionActions.SEND_OR_VALIDATE_OTP_ERROR: {
      return {
        ...state,
        otpLoading: false,
        otpError: action.payload.error,
        otpResponse: null,
      };
    }

    default:
      return state;
  }
};

const addNewFieldMap = (
  newFields: FieldProps[],
  existingFieldMap: any,
  isReplace?: boolean
) => {
  newFields?.forEach((field: FieldProps) => {
    const fieldId = field?.localId;
    const existingField = existingFieldMap[fieldId];
    existingFieldMap[fieldId] =
      existingField && !isReplace ? { ...field, ...existingField } : field;
  });
  return { ...existingFieldMap };
};

const getUpdatedFieldMap = (
  newFields: FieldProps[],
  existingFieldMap: any,
  isReplace?: boolean
) => {
  newFields?.forEach((field: FieldProps) => {
    const fieldId = field?.localId;
    if (fieldId) {
      const existingField = existingFieldMap[fieldId];
      existingFieldMap[fieldId] =
        existingField && !isReplace ? { ...existingField, ...field } : field;
    }
  });
  return { ...existingFieldMap };
};

const getClientSubmissionData = (formSubmissionData) => {
  const formSubmissionMap: IFormSubmissionMap = {};
  const submissionMap: ISubmissionMap = {};
  const submissionIds: string[] = [];
  formSubmissionData &&
    formSubmissionData.submissions.map((submissionData) => {
      const formatedSubmissionData: IFormSubmission = {
        localId: "",
        fieldSubmissionMap: {},
      };
      submissionData && submissionIds.push(submissionData.localId),
        submissionData.fieldSubmissionMap &&
        submissionData.fieldSubmissionMap.map((fieldData, index) => {
          formatedSubmissionData.fieldSubmissionMap[fieldData.localId] =
            fieldData;
        });
      formatedSubmissionData.localId = submissionData.localId;
      submissionMap[submissionData.localId] = formatedSubmissionData;
    });

  formSubmissionMap[formSubmissionData.formId] = submissionIds;
  return [formSubmissionMap, submissionMap];
};
